@if (localization.currentLocale$ | async; as currentLang) {
  <button type="button"
    [cdkMenuTriggerFor]="dropdown"
    (cdkMenuClosed)="showDropdown = false"
    (cdkMenuOpened)="showDropdown = true"
    class="main-link"
    >
    <span>{{ currentLang | uppercase }}</span>
    <span appIcon="chevron-down"
      class="chevron"
      [class.inverted]="showDropdown"
    ></span>
  </button>
  <ng-template #dropdown>
    <div cdkMenu class="dropdown">
      <p class="heading">
        {{ 'common.language' | translate }}
      </p>
      <div class="options">
        @for (lang of langList; track lang) {
          <a
            [ssrHref]="'/' + lang"
            >
            <button (click)="setLanguage(lang)"
              type="button"
              cdkMenuItem
              >
              @if (currentLang === lang) {
                <span
                  appIcon="checkmark"
                  class="checkmark"
                ></span>
              }
              {{ langLabels[lang] }}
            </button>
          </a>
        }
      </div>
      @if (authService.user$ | async) {
      } @else {
        <hr class="underline">
        <p class="heading">
          {{ 'register.country' | translate }}
        </p>
        <div class="options">
          @for (country of countries; track country) {
            <button [disabled]="currentCountry === country.value"
              cdkMenuItem
              type="button"
              (click)="setCountry(country.value)"
              >
              @if (currentCountry === country.value) {
                <span
                  appIcon="checkmark"
                  class="checkmark"
                ></span>
              }
              {{ country.label | translate }}
            </button>
          }
        </div>
      }
    </div>
  </ng-template>
}
